﻿import { CategoriesValuesDef, Entity, MicroMClient } from "@mcurros2/microm";

export class catTiposDomicilio extends Entity<CategoriesValuesDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new CategoriesValuesDef(), parentKeys);
        this.def.columns.c_category_id.value = "TiposDomicilio";
        this.def.columns.c_category_id.defaultValue = "TiposDomicilio";
        this.Title = "Tipos de domicilio";
    }
}